import NavBar from "../Components/Common/navBar";
import Footer from "../Components/Common/footer";
import TeamMember from "../Components/Team/teamMember";

import teamInfo from "../Data/team";

import "./styles/team.css";

const Team = () => {
    return (
        <div className="teamContainer">
            <NavBar />

            <div className="teamTitle">
                <h2>Meet Our Team</h2>
                <p>Professional & High Quality</p>
            </div>
            
            <div className="teammates">
                <TeamMember picture={teamInfo[1].picture} name={teamInfo[1].name} role={teamInfo[1].role} description={teamInfo[1].description} />
                <TeamMember picture={teamInfo[2].picture} name={teamInfo[2].name} role={teamInfo[2].role} description={teamInfo[2].description} />
                <TeamMember picture={teamInfo[3].picture} name={teamInfo[3].name} role={teamInfo[3].role} description={teamInfo[3].description} />
                <TeamMember picture={teamInfo[4].picture} name={teamInfo[4].name} role={teamInfo[4].role} description={teamInfo[4].description} />
                <TeamMember picture={teamInfo[5].picture} name={teamInfo[5].name} role={teamInfo[5].role} description={teamInfo[5].description} />
                <TeamMember picture={teamInfo[6].picture} name={teamInfo[6].name} role={teamInfo[6].role} description={teamInfo[6].description} />
                <TeamMember picture={teamInfo[7].picture} name={teamInfo[7].name} role={teamInfo[7].role} description={teamInfo[7].description} />
                <TeamMember picture={teamInfo[8].picture} name={teamInfo[8].name} role={teamInfo[8].role} description={teamInfo[8].description} />
                <TeamMember picture={teamInfo[9].picture} name={teamInfo[9].name} role={teamInfo[9].role} description={teamInfo[9].description} />
                <TeamMember picture={teamInfo[10].picture} name={teamInfo[10].name} role={teamInfo[10].role} description={teamInfo[10].description} />
                <TeamMember picture={teamInfo[11].picture} name={teamInfo[11].name} role={teamInfo[11].role} description={teamInfo[11].description} />
                <TeamMember picture={teamInfo[12].picture} name={teamInfo[12].name} role={teamInfo[12].role} description={teamInfo[12].description} />
                <TeamMember picture={teamInfo[13].picture} name={teamInfo[13].name} role={teamInfo[13].role} description={teamInfo[13].description} />
            </div>

            <Footer />
        </div>
    )
}	

export default Team;